module.exports = {"API_BASE_URL":"https://staging-backend.perfecttense.com","WS_BASE_URL":"https://staging-backend.perfecttense.com/cable","DEFAULT_PLAN_ID":4,"STRIPE_PUBLISHABLE_KEY":"pk_test_8wZS6oRk3iPfyyrkV6y33IbB","ZENDESK_API_URL":"https://perfecttense.zendesk.com/api/v2","ZENDESK_TOKEN":"eb46974572fbdf9afe8f1b8eb346510035a8ec6ec27d18e8574e563fa9ac7c7c","LANDING_PAGE_URL":"https://staging-www.perfecttense.com","COOKIE_DOMAIN":".perfecttense.com","LIVE_EDITOR_SOCKET_URL":"wss://staging-io.perfecttense.com","API_ENV":"staging"}


//////////////////
// WEBPACK FOOTER
// ../shared/secrets.json
// module id = ../shared/secrets.json
// module chunks = 3 4 5